module.exports = __webpack_public_path__ + "img/an_bg.58174afe.jpg";